/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./view-dialog.vue?vue&type=template&id=22564aed&scoped=true&"
import script from "./view-dialog.vue?vue&type=script&lang=ts&"
export * from "./view-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./view-dialog.vue?vue&type=style&index=0&id=22564aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22564aed",
  null
  
)

export default component.exports